import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { AxiosRequestConfigMethods } from "@/api/types";
import { EnvironmentVariables } from "@/modules/common/types";
import { ZoomCallsFilters, ZoomCallsResponse, ZoomCallsFlatResponse } from "@/modules/zoom-calls/types";

export const getZoomCalls = async (
  filters: ZoomCallsFilters,
  pagination: { page: number; pageSize: number }
): Promise<ZoomCallsResponse> => {
  const apiUrl = brandUrl<ZoomCallsResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/zoom-calls`
  );
  const response = await fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        ...filters,
        ...pagination,
      },
    },
  });
  return response.data;
};

export interface GenerateZoomCallAiStatusResponse {
  suggestedStatusId: number | null;
  suggestedStatusName: string | null;
  suggestedStatusColor: string | null;
  oldStatusId: number;
  oldStatusName: string;
  oldStatusColor: string;
  generatedAt: string;
}

export const generateZoomCallAiStatus = async (
  uid: string,
): Promise<GenerateZoomCallAiStatusResponse> => {
  const apiUrl = brandUrl<GenerateZoomCallAiStatusResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/zoom-calls/${uid}/generate-ai-status`,
  );
  const response = await fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
    },
  });
  return response.data;
};

export const getZoomCallsFlat = async (
  filters: ZoomCallsFilters & { customerUid?: string },
  pagination: { page: number; pageSize: number }
): Promise<ZoomCallsFlatResponse> => {
  const apiUrl = brandUrl<ZoomCallsFlatResponse>(
    `${EnvironmentVariables.NEW_CRM_BASE_API_URL}/zoom-calls/calls`
  );
  const response = await fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: {
        ...filters,
        ...pagination,
      },
    },
  });
  return response.data;
};
